import React, { useState, useEffect, useRef, useCallback, useMemo, createRef } from 'react';
import { Icon, SvgIcon, TableCell, TableHead, TableRow, TableSortLabel } from '@material-ui/core';
import KeyboardArrowDownSharpIcon from '@material-ui/icons/KeyboardArrowDownSharp';

export default function EnhancedTableHead(props) {
    const { classes, onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } = props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    const [headCells] = useState([
        { name: 'last_name', title: 'Student', isSortable: true },
        { name: 'actions', title: 'Actions', isSortable: false, align: 'center' },
    ]);

    return (
        <TableHead>
            <TableRow>
                {headCells.map((headCell) =>
                    headCell.isSortable ? (
                        <TableCell
                            key={headCell.name}
                            align={headCell.align ? 'right' : 'left'}
                            padding={headCell.disablePadding ? 'none' : 'default'}
                            sortDirection={orderBy === headCell.name ? order : false}
                        >
                            <TableSortLabel
                                IconComponent={KeyboardArrowDownSharpIcon}
                                active={orderBy === headCell.name}
                                direction={orderBy === headCell.name ? order : 'asc'}
                                onClick={createSortHandler(headCell.name)}
                            >
                                {headCell.title}
                            </TableSortLabel>
                        </TableCell>
                    ) : (
                        <th key={headCell.name}>{headCell.title}</th>
                    )
                )}
            </TableRow>
        </TableHead>
    );
}
